import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DashboardService } from '../../../services/dashboard.service';
import { CustomerService } from '../../../services/customer.service';
import { CommonModule } from '@angular/common';
import { CardModule } from 'primeng/card';
import { catchError, forkJoin, map, of, switchMap } from 'rxjs';
import { InventoryService } from '../../../services/inventory.service';
import { SalesService } from '../../../services/sales.service';
import { VendorService } from '../../../services/vendor.service';

@Component({
  selector: 'app-top-aaccounting-recods-lookup',
  standalone: true,
  imports: [CommonModule, CardModule],
  templateUrl: './top-aaccounting-recods-lookup.html',
  styleUrls: ['./top-aaccounting-recods-lookup.scss']
})
export class TopAaccountingRecodsLookup {
  type!: 'receivables' | 'payables';
  records: any[] = [];
  loading = false;
today = new Date();
  constructor(
  public ref: DynamicDialogRef,
  public config: DynamicDialogConfig,
  private dashboardService: DashboardService,
  private vendorService: VendorService,
  private salesOrderService: SalesService,
  private customerService: CustomerService
) {}

  ngOnInit(): void {
    this.type = this.config.data.type;
    this.loadTopRecords();
  }

  loadTopRecords() {

  if (this.type === 'receivables') {

  this.dashboardService.getTopReceivables().subscribe({
      next: (res: any[]) => {

        const requests = res.map(record => {

          if (record.customerId) {
            return this.customerService.getCustomerById(record.customerId).pipe(
              map(customer => {
                record.customerName = customer?.customerName || '-';
                return record;
              }),
              catchError(() => {
                record.customerName = record.createdBy || '-';
                return of(record);
              })
            );
          }

          return of(record);
        });

        forkJoin(requests).subscribe(finalData => {
          this.records = finalData;
        });

      },
      error: err => console.error(err)
    });

  } else {

    this.dashboardService.getTopPayables().subscribe({
      next: (res: any[]) => {

        const requests = res.map(record => {

          if (record.vendorId) {
            return this.vendorService.getVendorById(record.vendorId).pipe(
              map(vendor => {
                record.vendorName = vendor?.vendorName || '-';
                return record;
              }),
              catchError(() => {
                record.vendorName = record.createdBy || '-';
                return of(record);
              })
            );
          }

          return of(record);
        });

        forkJoin(requests).subscribe(finalData => {
          this.records = finalData;
        });

      },
      error: err => console.error(err)
    });

  }
}

  selectRecord(record: any) {
    this.ref.close(record);
  }

formatINR(amount: number): string {
  if (amount == null) return '₹ 0.00';
  return new Intl.NumberFormat('en-IN', { 
    style: 'currency', 
    currency: 'INR', 
    minimumFractionDigits: 2, 
    maximumFractionDigits: 2 
  }).format(amount);
}

}
